export default __webpack_public_path__ + "static/media/pm1.75c745d0.jpg";